export default {
  /**
   * @type {{logs: Array, checkMoreLogs: boolean, endDateForNextRequest: import('moment').Moment }}
   */
  changeLogs: {},

  status: {},
};